import { useInvoiceSpecificationsColumnOverrides } from "@/modules/projects/hooks/useInvoiceSpecificationsSectionColumnOverrides";
import { ReadInvoiceSpecification } from "@/types/invoiceSpecification";
import { useCallback, useMemo } from "react";

export function useInvoiceSpecificationList() {
  const columnOverrides = useInvoiceSpecificationsColumnOverrides();

  const getRowProps = useCallback(function <T>(row: {
    original: T;
  }): Record<string, unknown> {
    const isDeleted = (row.original as ReadInvoiceSpecification).deleted_at;
    return isDeleted ? { className: "bg-red-50/70" } : {};
  }, []);

  const tableFeatures = useMemo(
    () => ({
      getRowProps,
    }),
    [getRowProps],
  );

  return { columnOverrides, tableFeatures };
}
